import { UserMessages } from "definitions/Locale"

const newUserMessages: UserMessages = {
  pt: {
    translations: {
      loading: "Carregando",
      selectTicketType: "Tipo de atendimento",
      statusForRefusedChat: "Status para chat rejeitado pelo cliente",
      selectTemplateToSeeMessage: "Selecione um template para ver a mensagem",
      selectTemplate: "Selecione um template",
      chooseCompany: "Escolha a empresa",
      messageSentToCustomer: "Mensagem enviada com sucesso",
      stayOnThisPage: "Permanecer nesta página ao enviar",
      toClose: "fechar",
      sendWhatsappMessageToCustomerModalTitle: "Envio de mensagem para",
      enterKeySendsMessage:
        "Enter envia mensagem (pressione com CTRL ou SHIFT para nova linha)",
      confirmPostImage:
        "Confirma envio de imagem colada da área de transferência?",
      readAll: "Ler todas",
      operator: "Atendente",
      newUserHeader: "Cadastrar usuario",
      newCompany: "Cadastrar empresa",
      profileHeader: "Perfil",
      welcomeHeader: "Bem vindo ao",
      loginHeader: "LOGIN",
      changePassword: "Alterar senha",
      inOpen: "Em aberto hoje",
      inAttendance: "Em atendimento",
      searchPerAttendant: "Buscar por atendente",
      awaitingClient: "Aguardando cliente",
      awaiting: "Em espera",
      show: "Mostrar",
      perTimeTicket: "registros por vez",
      newPassword: "Nova senha",
      closed: "Encerrado",
      callData: "Dados do chamado",
      clientData: "Dados do cliente",
      searchClient: "Pesquisar cliente",
      customFields: "Campos customizados",
      selectTicket: "Selecione um ticket",
      howCanHelp: "Em que posso ajudar ?",
      infoToStart: "Para iniciarmos precisamos de algumas informações iniciais",
      config: "Configurações",
      apparence: "Aparência",
      fantasy: "Fantasia",
      responsible: "Responsável",
      action: "Ação",
      clients_export: "Clientes - Exportar",
      clients_import: "Clientes - Importar",
      clients: "Clientes",
      attDate: "Data de atualização",
      sendDate: "Data de envio",
      implementCode: "Codigo para implementação",
      implementCodeSkute: "Codigo para implementação do widget",
      putExclude: "Digite EXCLUIR para continuar",
      ignored: "Ignorado",
      number: "Número",
      login: "Login",
      name: "Nome",
      logo: "Logo",
      nickname: "Apelido",
      contact: "Contato",
      Contact: "Contato",
      bornDate: "Nascimento",
      document: "CPF",
      email: "Email",
      profile: "Perfil",
      company: "Empresa",
      initialPassword: "Senha inicial",
      password2: "Senha",
      confirmPassword: "Confirmar senha",
      secundaryEmail: "Email Secundário",
      phone: "Telefone",
      cellphone: "Celular",
      branch: "Ramal",
      zipCode: "CEP",
      address: "Endereço",
      complement: "Complemento",
      neighborhood: "Bairro",
      city: "Cidade",
      state: "Estado",
      scheduling: "Agendamento",
      sellEmail: "E-Mail de vendas",
      companyReturnContact: "A empresa retornou contato?",
      currectData: "Os dados estão corretos ?",
      confirmEmailGeneration: "Deseja gerar um e-mail para o cliente?",
      emailGenerationText:
        "O cliente não possui endereço de e-mail. Deseja gerar um endereço de e-mail automático?",
      wantSave: "Sim, quero salvar !",
      newContact: "Novo contato",
      finalRegister: "Cadastro final",
      search: "Pesquisar",
      status: "Status",

      date: "Data",
      standardColor: "Cor padrão",
      backgroundColor: "Cor de fundo",
      answerBoxColor: "Cor da caixa de resposta do usuário",
      companyBoxColor: "Cor da caixa de respostas da empresa.",
      socialReason: "Razão Social",
      registry: "CNPJ",
      category: "Categoria",
      site: "Site",
      text: "Texto",
      answerExample: "Resposta ex: (1) ou (2)",
      goToOperator: "Vai para atendente",
      endOfBot: "Fim do bot",
      backToStart: "Voltar para o início",
      onlyOneChild: "Somente uma interação como filha.",
      removeChildsFirst: "Remova primeiro os filhos para remover o pai",
      description: "Descrição",
      wordsToAddOperator:
        ' Palavras para acionar o atendente ( separadas por ",")',
      numberOfTries: "Numero de tentativas antes de redirecionar ao atendente",
      wordsToRedirect: "Mensagens de encaminhamento para o atendente",
      callDistribution: "Chamados são distribuidos automaticamente a cada",
      calls: "Chamado(s)",
      callNotDistribution: "Chamados não são distribuidos automaticamente",
      user: "Usuário",
      password: "Senha",
      save: "Salvar",
      confirm: "Confirmar",
      reset: "Resetar",
      resetPassword: "Resetar senha",
      cancel: "Cancelar",
      getBack: "Voltar",
      openInOpen: "Abrir no OPEN",
      unify: "Unificar",
      unifyClient: "Unificar cliente",
      assume: "Assumir",
      assumeTicket: "Assumir Ticket",
      start: "Iniciar",
      importClients: "IMPORTAR CLIENTES",
      exportClient: "EXPORTAR CLIENTES",
      downloadModel: "BAIXAR MODELO",
      newClient: "NOVO CLIENTE",
      add: "Adicionar",
      clickToStart: "Clique aqui para começar",
      language: "Idioma",
      select: "Selecione",
      genderOption: "Sexo",
      rememberEmail: "E-Mail lembrete",
      activeCall: "Ligação ativa",
      type: "Tipo",
      subType: "Sub-Tipo",
      redirectCall: "Redirecionar chamado",
      callStatus: "Status de chamado",
      shortcuts: "Atalhos",
      answerType: "Tipo de resposta",
      empty: "Selecione um idioma",
      portuguese: "Português",
      spanish: "Espanhol",
      genderMenOption: "Masculino",
      genderFemaleOption: "Feminino",
      genderNotInformed: "Não Informado",
      yes: "Sim",
      no: "Não",
      selectChannel: "Selecione o canal",
      emptyChannels: "Nenhum canal encontrado.",
      createNew: "Criar novo",
      chooseOne: "Selecione um",
      menuOption: "Opção de menu",
      image: "Imagem",
      languageChange: "Pagina irá recarregar para aplicar mudanças !",
      forgotPassword: "Esqueceu a senha?",
      archive: "Arquivo",
      publications: "Não há novas publicações",
      notifications: "Notificações",
      exit: "Sair",
      noCompanyRegistered: "Nenhuma empresa cadastrada",
      noExportationFinded: "Nenhuma exportação encontrada",
      noImportationsFinded: "Nenhuma importação encontrada",
      errors: "Erros",
      allowAttUsers: "Permite atualizar usuários",
      ifAllow:
        "Ao permitir atualizar o usuário, se for encontrado CPF/CNPJ na base, os dados do cliente serão atualizados.",
      picture: "Foto",
      openIntegrationError: "Essa empresa não existe no open.",
      noClientsRegistered: "Nenhum cliente cadastrado",
      noChannelsFinded: "Nenhum canal encontrado",
      quantity: "Quantidade",
      deadLine: "Prazo em",
      channel: "Canais",
      attendanceBot: "Bot de atendimento",
      createBot: "Criar bot",
      editBot: "Editar bot",
      attemption: "Atenção",
      confirmUnify: "Você tem certeza que deseja unificar os cadastros ?",
      acceptUnify: "Sim, quero unificar !",
      eraseCompany: "Você tem certeza que deseja excluir essa empresa?",
      confirmEraseCompany: "Sim, quero confirmar !",
      confirmReproveCompany: "Sim, quero reprovar !",
      eraseClient: "Você tem certeza que deseja excluir esse cliente?",
      desire: "O que você deseja ?",
      edit: "Editar",
      create: "Criar",
      delete: "Excluir",
      deleteCompany: "Excluir empresa",
      deleteDesire: "Você tem certeza que deseja excluir?",
      reproveDesire: "Você tem certeza que deseja reprovar essa empresa?",
      deleteHolliday: "Você tem certeza que deseja excluir esse feriado?",
      noHollidayFinded: "Nenhum feriado encontrado",
      noCategoryFound: "Nenhuma categoria encontrada",
      deleteHours:
        "Você tem certeza que deseja excluir esse(s) horário(s) de atendimento?",
      businessHoursNotFound: "Nenhum horario encontrado",
      startHour: "Horário de inicio",
      endHour: "Horário de fim",
      days: "Dia(s)",
      invalidHour: "Horários de atendimento inválidos!",
      startHourFinalHour: "Horário de início deve ser menor que horário final!",
      selectOneDay: "Selecione ao menos um dia da semana!",
      sunday: "Domingo",
      monday: "Segunda-Feira",
      tuesday: "Terça-Feira",
      wednesday: "Quarta-Feira",
      thursday: "Quinta-Feira",
      friday: "Sexta-Feira",
      saturday: "Sábado",
      title: "Título",
      message: "Mensagem",
      deleteShortcut: "Você tem certeza que deseja excluir esse atalho?",
      noShortcutFinded: "Nenhum atalho encontrado",
      deleteSLA: "Você tem certeza que deseja excluir esse SLA?",
      noSLAFinded: "Nenhum SLA encontrado",
      externalDescription: "Descrição externa",
      internalDescription: "Descrição interna",
      deleteStatus: "Você tem certeza que deseja excluir esse Status?",
      noStatusFinded: "Nenhum status encontrado",
      default: "padrão",
      defaultTicket:
        "Você tem certeza que deseja colocar esse tipo de ticket como padrão?",
      defaultType: "Tipo Padrão no atendimento",
      deleteTicket: "Você tem certeza que deseja excluir esse tipo de ticket?",
      noTicketFinded: "Nenhum tipo de ticket encontrado",
      defaultTicketType: "Tipo padrão",
      delay: "Atraso",
      superDelay: "Super atraso",
      delayRisk: "Risco de atraso",
      openingHour: "Horários de atendimento",
      holliday: "Feriados",
      callsDistribution: "Configuração de ambiente",
      userTypes: "Tipos de usuário",
      ticketType: "Tipo de ticket",
      attendanceShortcut: "Atalhos de atendimento",
      bot_config: "Bot - Aparência",
      deleteUserType:
        "Você tem certeza que deseja excluir esse tipo de usuário ?",
      noUserTypeFinded: "Nenhum tipo de usuario encontrado",
      userType: "Tipo de usuário",
      loggedOperators: "Atendentes logados",
      expiredSLA: "SLA Expirado",
      concluded: "Concluído hoje",
      tickets: "Tickets",
      inQueue: "Fila",
      averageToday: "Media hoje",
      maximunToday: "Máximo hoje",
      attendance: "Atendimento",
      ticketsOppenedTodayByChannel: "Tickets abertos hoje por canal",
      ticketsOppenedTodayByType: "Tickets abertos hoje por tipo",
      partner: "Parceiro",
      noPartner: "Não parceiro",
      noBelong: "Não faz parte",
      perChannel: "Por canal",
      startDate: "Data inicial",
      endDate: "Data Final",
      noInfoFinded: "Nenuma informação encontrada",
      perState: "Por estado",
      perProtocolType: "Por tipo de protocolo",
      byUser: "Por cliente",
      about: "Sobre",
      subtitle: "Subtítulo",
      productsAndServices: "Produtos e Serviços",
      event: "Evento",
      attachment: "Anexo",
      externalSite: "Site externo",
      linkText: "Texto link",
      preview: "Preview",
      previewFeed: "Preview Feed SKUTE",
      deleteFeed: "Você tem certeza que deseja excluir esse Feed?",
      noFeedFinded: "Nenhum feed encontrado",
      createdAt: "Criado em",
      eventsRegistry: "Registro de eventos",
      likes: "Curtidas",
      assessments: "Avaliações",
      backToBusiness: "Voltaria a fazer negocios ?",
      backToBusiness2: "Voltaria a fazer negocios",
      comentary: "Comentário",
      replic: "Réplica",
      reject: "Rejeitar",
      approve: "Aprovar",
      comentaryRejected:
        "Comentários rejeitados não aparecem na página da empresa, porém tem sua nota considerada.",
      all: "Todos",
      NoReviewsFound: "Nenhuma avaliação encontrada",
      noSchedulingFound: "Nenhum agendamento encontrado",
      deleteSheduling: "Você tem certeza que deseja excluir esse Agendamento?",
      protocol: "Protocolo",
      deleteUser: "Você tem certeza que deseja excluir esse usuário?",
      noUsersFound: "Nenhum usuario encontrado",
      photo: "Foto",
      onlyPending: "Apenas pendentes",
      showInactive: "Apenas ativos",
      shedulingToday: "Agendamentos de hoje",
      perStatus: "Por status - Hoje",
      perLate: "Em atraso - Hoje",
      late: "Em atraso",
      avaliations: "SKUTE - Minhas avaliações",
      deleteScheduling: "Tem certeza que deseja excluir esse agendamento ?",
      schedulingperWeek: "Atendimentos por semana",
      latePerWeek: "Em atraso na semana",
      january: "Janeiro",
      february: "Fevereiro",
      march: "Março",
      april: "Abril",
      may: "Maio",
      june: "Junho",
      july: "Julho",
      august: "Agosto",
      september: "Setembro",
      october: "Outubro",
      november: "Novembro",
      december: "Dezembro",
      send: "Enviar",
      informALogin: "Por favor, informe um login.",
      minimumPassword: "A senha deve possuir, pelo menos 5 caractéres.",
      passwordNotMatch: "As senhas não coincidem !",
      doesNotHaveBot: "Não possui nenhum bot",
      none: "Nenhum",
      successCopy: "Texto copiado para sua area de transferência!",
      reprove: "Reprovar",
      pending: "Pendente",
      ticketOcorrency: "Há ocorrência(s)  aberta(s) para esse cliente.",
      updatedAt: "Data Últ. Atu",
      userActive: "Ativo",
      onlyDueDate: "Apenas empresa vencida",
      hideTopMenu: "Esconder menu",
      systemVariables: "Variáveis de sistema",
      backToLogin: "Voltar para o login",
      showTopMenu: "Mostrar menu",
      inactive: "Inativo",
      today: "Hoje",
      yesterday: "Ontem",
      noPermission: "Você não tem permissão.",
      noAgentOnline: "Nenhum atendente online.",
      reload: "Atualizar",
      approved: "Aprovado",
      callAgent: "Chamar o agente",
      agent: "Agente",
      errorsBeforeAgent: "Erros antes do agente",
      messageToAgent: "Mensagem de encaminhamento para o agente",
      noBotFinded: "Nenhum bot encontrado",
      confirmEraseBot: "Sim, confirmar !",
      deleteBot: "Você tem certeza que deseja excluir o bot?",
      nextStep: "Próximo Passo",
      selectOperator: "Selecione o atendente",
      anyOperator: "Qualquer atendente",
      noCallOperator: "Nenhuma opção para chamar operador.",
      backStep: "Voltar passo",
      doubleInteractionOption:
        "Não é possivel criar uma opção de menu em outra opção de menu.",
      question: "Pergunta",
      option: "Opção",
      interaction: "Interação",
      registryLater: "Cadastrar depois",
      concludedStatus: "Status de conclusão",
      expectedAnswer: "Resposta esperada",
      firstMenuOption:
        "Não é possivel criar uma opção de menu no inicio do bot",
      nodeWithoutFather: "Não é possivel colocar uma opção/pergunta sem um pai",
      optionsMenuInQuestion:
        "Opção de menu não pode ser movido para uma pergunta",
      clientsTypes: "Tipos de cliente",
      totalTickets: "Número de tickets deste cliente.",
      errorImage: "Ocorreu um erro ao carregar a imagem",
      errorVideo: "Ocorreu um erro ao carregar o video",
      errorAudio: "Ocorreu um erro ao carregar o áudio",
      errorFile: "Ocorreu um erro ao carregar o arquivo",
      companyCategory: "Categorias de empresa",
      registerTrialAccount: "Cadastro de conta Trial",
      endTrial: "Seu periodo trial acabou, entre em contato com o suporte",
      endTrial1: "Sua conta trial acabará em",
      endTrial2: "dia(s), caso queira aumentar, contate o suporte.",
      usersLimit: "Limíte de usuários",
      newUserLimit: "Esta conta só permite logar até",
      noPermissionToNewUser:
        "Você já atingiu o limite de usuários na sua conta, contate o suporte para liberar mais !",
      administration: "Administrativo",
      renewForMonth: "Renovar por 1 mês",
      returnPausePassword: "Exigir autenticação ao voltar da pausa",
      inform: "Informar",
      validDate: "Dia de vencimento",
      maxUsers: "Máximo de usuarios permitidos",
      toleranceDays: "Dias de tolerância",
      acessLimitDate: "Data limite de acesso",
      offline:
        "Você está offline, por favor verifique sua conexão com a Internet.",
      reconnected: "Sua conexão foi reestabelecida",
      contactSuport: "Contate o suporte para liberar mais.",
      loginSugest: "Sugestão de login: empresa.login",
      loginExample: "Exemplo: google.atendente",
      accountExpired:
        "A sua conta venceu, entre em contato com um suporte para continuar usando.",
      simultaneously: "simultaneamente",
      responsibleEmail: "Email do responsável",
      responsiblePhone: "Telefone do responsável",
      activeUntilThen: "Ativo até",
      exportAllData: "Exportar todos os dados",
      dontHave: "Não possui",
      cantContinueInteraction:
        "Não é possivel continuar interação/opção que redireciona para outra interação.",
      cantContinueEndOfBot:
        "Não é possivel continuar interação/opção que finaliza o bot ou envia para um operador.",
      informactive: "Informativo",
      cantRemoveWithNextInteraction:
        "Não é possivel excluir uma interação que redirecione para outra, primeiro exclua a próxima.",
      detachedInteraction: "Interação desvinculada",
      timeZone: "Fuso-Horário",
      alreadyHaveAnswer: "Já possui uma opção com esta resposta",
      botLinked: "Bot está ativo no canal",
      botLinked2: ", para apagar desvincule o bot.",
      perTime: "Relatório por tempo de atendimento",
      perAgent: "Controle de pausas",
      totalOfTickets: "Total de tickets",
      assignedTickets: "Tickets assumidos",
      noData: "Nenhum dado encontrado",
      totalPauses: "Total de pausas",
      totalPausesDuration: "Tempo de pausa total(HH:MM:SS)",
      openIntegration: "Possui integração com o Open",
      informSystem: "Informe o sistema",
      continueBot: "Continuar Bot",
      departments: "Departamentos",
      defaultDepartment: "Departamento padrão",
      deleteDepartment:
        "Você tem certeza que deseja excluir esse departamento?",
      departmentDefaultDeleteInformMessage:
        "O departamento está definido como padrão, defina outro departamento como padrão para poder excluí-lo.",
      confirmChangeUserProfile: "Confirmar mudança de perfil do usuário?",
      changeUserProfile:
        "Ao trocar o perfil do usuário ele será desatrelado de todas às empresas em que foi cadastrado.",
      notSelectedCompanyDepartmentError:
        "O Usuário deve possuir um cargo em todas as empresas em que será cadastrado.",
      goToDepartment: "Vai para departamento",
      selectDepartment: "Selecione o departamento",
      department: "Departamento",
      perDepartment: "Por departamento",
      rememberClient: "Relembrar cliente",
      enableRememberClient: "Habilitar notificação/finalização automática",
      maxRememberClientTries:
        "Quantidade máxima de notificações antes de fechamento automático",
      intervalBetweenRememberClientTries: "Intervalo entre notificações",
      rememberClientMessage: "Mensagem de notificação",
      automatiCloseTicketMessage: "Mensagem de fechamento automático",
      setTicketTypeToCloseTicket:
        "É necessário definir o tipo antes de concluir o ticket",
      newBusinessHourTitle: "Novo horário de funcionamento",
      warningStartTimeGreaterThanEndTime:
        "Horário de início não pode ser igual ou maior que horário de encerramento",
      warningEndTimeLessThanStartTime:
        "Horário de encerramento não pode ser igual ou maior que horário de início",
      members: "Membros",
    },
  },
}

export { newUserMessages }
